module.exports = __webpack_public_path__ + "img/nandaoshi.1072f822.png";